import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { Distance } from "../units/Units"
import type { BasePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_media
export type PlotMedia = {
  enum: PlotFunction.PLOT_MEDIA
  crop_position: SpatialRectangle<Distance>
  media_position: SpatialRectangle<Distance>
  page: string
} & BasePlotObject
